import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { constants } from '@bingads-webui/instrumentation';

const preferenceService = globalContext.requireDefault('component/preference/service/index');
const state = globalContext.require('component/state/index');
const popup = globalContext.require('component/dialog/popup');
const { appendLearnMoreLink } = globalContext.require('component/help/index');
const { getTimeZoneForDateRangeText } = globalContext.require('component/timezonemapper/index');
const { PopoverView, positions, contents } = globalContext.require('campaignui/feature/popover/index');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/shopping-campaign');
const i18nGlobal = globalContext.require('$/i18n!legacy/global');
const config = globalContext.require('component/config/index');
const cacheManager = globalContext.requireDefault('campaignui/feature/cache-manager/index');
const odata = globalContext.require('component/http/channel/odata');
const { getODataErrors } = globalContext.require('component/api-errors-campaign/index');
const DoubleListBox = globalContext.require('component/double-list-box/view/doubleListBox');
const decimal = globalContext.require('component/humanize/decimal');
const s$ProductPartition = globalContext.require('$/schema!campaign/ProductPartition');
const s$ProductGroup = globalContext.require('$/schema!campaign/ProductGroup');
const logger = globalContext.require('module/service/instrumentation/index');
const s$i18n = globalContext.require('$/schema-i18n!campaign');
const edmCampaign = globalContext.requireDefault('component/edm-campaign/index');
const { DownloadView } = globalContext.require('campaignui/feature/griddownload/view/adapter');
const jsData = globalContext.require('component/js-data-campaign/index');
const popupUtil = globalContext.require('module/service/shared/popup');
const bulkEditView = globalContext.require('module/view/bulkEdit/productgroup/changeBidOrBidBoost');
const bulkEditModel = globalContext.require('module/model/bulkEdit/productgroup/changeBidOrBidBoost');
const bulkEditCashbackPercentView = globalContext.require('module/view/bulkEdit/productgroup/changeCashbackPercent');
const bulkEditCashbackPercentModel = globalContext.require('module/model/bulkEdit/productgroup/changeCashbackPercent');
const pageContext = globalContext.require('PageContext');
const instrumentation = globalContext.requireDefault('campaignui/feature/instrumentation/index');
const dateUtils = globalContext.require('component/humanize/date');
const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');
const { Columns, SelectedColumns } = globalContext.require('component/bingads-grid/service/column-chooser-preferences');
const { LegacyColumns, LegacySelectedColumns } = globalContext.require('component/bingads-grid/service/legacy-column-chooser-preferences');
const InlineChartView = globalContext.requireDefault('campaignui/feature/inline-chart/view/inlinechartview');
const inlineChartConstants = globalContext.requireDefault('campaignui/feature/inline-chart/constants');
const sessionStore = globalContext.requireDefault('component/js-data-storage/session-storage');
const preferenceStoreFactory = globalContext.require('component/bingads-grid/service/filter-preferences').getFilters;
const cacheService = globalContext.require('Services/CacheService');
const dataContextManager = globalContext.require('SummaryDataContextManager');

const treeViewDeps = {
  preferenceService,
  state,
  popup,
  appendLearnMoreLink,
  getTimeZoneForDateRangeText,
  PopoverView,
  positions,
  contents,
  i18n,
  i18nGlobal,
  config,
  cacheManager,
  odata,
  getODataErrors,
  DoubleListBox,
  decimal,
  s$ProductPartition,
  s$ProductGroup,
  logger,
  s$i18n,
  edmCampaign,
  DownloadView,
  jsData,
  popupUtil,
  bulkEditView,
  bulkEditModel,
  bulkEditCashbackPercentView,
  bulkEditCashbackPercentModel,
  pageContext,
  instrumentation,
  dateUtils,
  bingadsGridColumn,
  Columns,
  SelectedColumns,
  LegacyColumns,
  LegacySelectedColumns,
  addDateChangeListener: (handler) => {
    window.App.views.Summary.bindDateFilterChangeHandler(handler);
  },
  InlineChartView,
  inlineChartConstants,
  sessionStore,
  preferenceStoreFactory,
  cacheService,
  dataContextManager,
  constants,
};

const flattenViewDeps = treeViewDeps;

export default {
  treeView: treeViewDeps,
  flattenView: flattenViewDeps,
};
